import "../../../App.css";
import React, { Component } from "react";
import { inject, observer } from "mobx-react";
import {
  BASE_URL, 
  API, 
  VERSION, 
  USER, 
  PLANNAR
} from "../../../Constants.js";
import Modal from "react-bootstrap/Modal";
import ModalHeading from "../../ModalHeading.jsx";
import SaveFileList from "../SaveFileList.jsx";
import Button from "react-bootstrap/Button";
import axios from "axios";
import LargeAlert from "../../LargeAlert.jsx";
import $ from "jquery";

@inject("store")
@observer
class LoadModal extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isDisabled: true,
      isError: false,
      fileName: "",
      fileUri: "",
      saveFileList: [],
      showModal: false,
      copied: false,
      removed: false,
      id: "",
    };

    this.handleClose = this.handleClose.bind(this);
    this.updateSaveFileList = this.updateSaveFileList.bind(this);
    this.handleClick = this.handleClick.bind(this);
    this.handleButtonClick = this.handleButtonClick.bind(this);
    this.handleRemove = this.handleRemove.bind(this);
    this.handleShare = this.handleShare.bind(this);
  }

  handleButtonClick() {
    if (this.state.fileUri !== null && this.state.fileUri !== "" && !this.state.isDisabled) {
      this.props.clickFunc(this.state.fileUri, this.state.id);
      this.handleClose();
    }
  }

  handleClose() {
    this.props.store.setLoadFileModal(false);
    this.setState({
      fileName: "",
      fileUri: "",
      showModal: false,
      isError: false,
      id: "",
    });
  }

  handleShare() {
    this.setState({ copied: true, isError: false, removed: false });
  }

  async handleRemove(id) {
    let token = this.props.store.getAccessToken;
    let config = {
      headers: { Authorization: `Bearer ${token}` },
    };
    try {
      await axios.delete(BASE_URL + API + VERSION + USER + PLANNAR + "/" + id, config);
      this.updateSaveFileList();
      this.setState({ removed: true, copied: false, fileName: "", id: "", uri: "" });
    } catch (e) {
      console.log(e);
      this.setState({ isError: true, copied: false, removed: false, fileName: "", id: "", uri: ""  });
    }
  }

  handleClick(id, name, uri, event) {
    this.setState({ id: id, fileName: name, fileUri: uri, isError: false, isDisabled: false });
    $(".save-file-list-item").css("border-color", "#ffffff");
    event.currentTarget.style.borderColor = "#5a6268";
  }

  async updateSaveFileList() {
    let token = this.props.store.getAccessToken;
    let config = {
      headers: { Authorization: `Bearer ${token}` },
    };
    try {
      let res = await axios.get(
        BASE_URL + API + VERSION + USER + PLANNAR,
        config
      );
      this.setState({ saveFileList: res.data, isError: false, copied: false, removed: false, fileName: "", id: "", uri: "" });
    } catch (e) {
      console.log(e);
      this.setState({ isError: true, copied: false, removed: false });
    }
  }

  componentDidUpdate(prevProps, prevState, snapShot) {
    if (this.props.store.showLoadFileModal && !prevState.showModal) {
      this.setState({ showModal: true, isError: false, copied: false, removed: false, fileName: "", id: "", uri: "" });
      this.updateSaveFileList();
    }
  }

  render() {
    const { store } = this.props;
    return (
      <Modal
        aria-labelledby="contained-modal-title-vcenter"
        centered
        show={store.showLoadFileModal}
        onHide={() => this.handleClose()}
        id="loadModal"
      >
        <Modal.Header closeButton>
          <Modal.Title>
            <ModalHeading icon="loadFile" message="Load Project" />
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="login-form-space">
            <SaveFileList
              clickFunc={this.handleClick}
              removeFunc={this.handleRemove}
              shareFunc={this.handleShare}
              fileList={this.state.saveFileList}
            />

            <Button
              variant="btn"
              className="login-submit-button"
              disabled={this.state.isDisabled}
              onClick={this.handleButtonClick}
            >
              Load
            </Button>

            {this.state.copied && (
              <LargeAlert
                variant="success"
                message="Link Copied to Clipboard"
              />
            )}
            {this.state.removed && (
              <LargeAlert
                variant="danger"
                message="Project removed"
              />
            )}
            {this.state.isError && (
              <LargeAlert variant="danger" message="Some Error Occurred" />
            )}
          </div>
        </Modal.Body>
      </Modal>
    );
  }
}

export default LoadModal;